import { render, staticRenderFns } from "./activateInfo.vue?vue&type=template&id=54d16fdf&scoped=true&"
import script from "./activateInfo.vue?vue&type=script&lang=js&"
export * from "./activateInfo.vue?vue&type=script&lang=js&"
import style0 from "./activateInfo.vue?vue&type=style&index=0&id=54d16fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d16fdf",
  null
  
)

export default component.exports